import { CheckCircle, Clock, XCircle } from 'lucide-react';
import { useState } from 'react';
import './AssignmentTracker.css';

export default function AssignmentTracker({ assignments, onStatusChange }) {
  const [filterStatus, setFilterStatus] = useState('all');

  const filteredAssignments = assignments.filter(
    (a) => filterStatus === 'all' || a.status === filterStatus
  );

  const stats = {
    confirmed: assignments.filter((a) => a.status === 'confirmed').length,
    pending: assignments.filter((a) => a.status === 'pending').length,
    total: assignments.length,
  };

  const handleStatusChange = (id, newStatus) => {
    onStatusChange(id, newStatus);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed':
        return <CheckCircle size={16} />;
      case 'pending':
        return <Clock size={16} />;
      case 'cancelled':
        return <XCircle size={16} />;
      default:
        return null;
    }
  };

  return (
    <div className="assignment-tracker">
      <div className="tracker-header">
        <div>
          <h2>Toewijzingen Overzicht</h2>
          <p>Houd toewijzingen en diensten bij</p>
        </div>
        <div className="stats">
          <div className="stat-item pending">
            <span className="stat-number">{stats.pending}</span>
            <span className="stat-label">In afwachting</span>
          </div>
          <div className="stat-item confirmed">
            <span className="stat-number">{stats.confirmed}</span>
            <span className="stat-label">Bevestigd</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{stats.total}</span>
            <span className="stat-label">Totaal</span>
          </div>
        </div>
      </div>

      <div className="tracker-controls">
        <div className="filter-buttons">
          <button
            className={`filter-btn ${filterStatus === 'all' ? 'active' : ''}`}
            onClick={() => setFilterStatus('all')}
          >
            Alle
          </button>
          <button
            className={`filter-btn ${filterStatus === 'pending' ? 'active' : ''}`}
            onClick={() => setFilterStatus('pending')}
          >
            In afwachting
          </button>
          <button
            className={`filter-btn ${filterStatus === 'confirmed' ? 'active' : ''}`}
            onClick={() => setFilterStatus('confirmed')}
          >
            Bevestigd
          </button>
          <button
            className={`filter-btn ${filterStatus === 'cancelled' ? 'active' : ''}`}
            onClick={() => setFilterStatus('cancelled')}
          >
            Geannuleerd
          </button>
        </div>
      </div>

      <div className="assignments-grid">
        {filteredAssignments.length > 0 ? (
          filteredAssignments.map((assignment) => (
            <div key={assignment.id} className={`assignment-card status-${assignment.status}`}>
              <div className="card-header">
                <div className="worker-info">
                  <h3>{assignment.workerName}</h3>
                  <p className="skill">{assignment.skill}</p>
                </div>
                <div className={`status-badge ${assignment.status}`}>
                  {getStatusIcon(assignment.status)}
                  <span>{({ pending: 'In afwachting', confirmed: 'Bevestigd', cancelled: 'Geannuleerd' })[assignment.status] || assignment.status}</span>
                </div>
              </div>

              <div className="card-details">
                <div className="detail-row">
                  <span className="label">Datum</span>
                  <span className="value">{new Date(assignment.date).toLocaleDateString('nl-NL', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                  })}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Tijd</span>
                  <span className="value">{assignment.time}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Klant</span>
                  <span className="value">{assignment.client}</span>
                </div>
              </div>

              <div className="card-actions">
                {assignment.status === 'pending' && (
                  <>
                    <button
                      className="action-btn confirm"
                      onClick={() => handleStatusChange(assignment.id, 'confirmed')}
                    >
                      Bevestigen
                    </button>
                    <button
                      className="action-btn cancel"
                      onClick={() => handleStatusChange(assignment.id, 'cancelled')}
                    >
                      Annuleren
                    </button>
                  </>
                )}
                {assignment.status === 'confirmed' && (
                  <button
                    className="action-btn mark-pending"
                    onClick={() => handleStatusChange(assignment.id, 'pending')}
                  >
                    Markeer als in afwachting
                  </button>
                )}
                {assignment.status === 'cancelled' && (
                  <button
                    className="action-btn restore"
                    onClick={() => handleStatusChange(assignment.id, 'pending')}
                  >
                    Herstellen
                  </button>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-assignments">
            <p>Geen toewijzingen gevonden</p>
          </div>
        )}
      </div>
    </div>
  );
}
